import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import en from '../locales/en/common.json'
import ro from '../locales/ro/common.json'
import fr from '../locales/fr/common.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: en },
      ro: { common: ro },
      fr: { common: fr },
    },
    supportedLngs: ['en', 'ro', 'fr'],
    fallbackLng: 'en',
    defaultNS: 'common',
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'sc_language',
    },
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
